// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"
import L from 'leaflet'

window.MAPY_API_KEY = 'fFRkuEy2S5ti6pbhMLjCS7iGbyTvno0vHzd7hZKubyU';

// Jodit lazy loading
let joditModulePromise

function ensureJoditStylesheet() {
  if (document.getElementById('jodit-styles')) return
  const link = document.createElement('link')
  link.id = 'jodit-styles'
  link.rel = 'stylesheet'
  link.href = 'https://cdn.jsdelivr.net/npm/jodit@4.6.2/es2021/jodit.min.css'
  document.head.appendChild(link)
}

function loadJodit() {
  if (window.Jodit) return Promise.resolve(window.Jodit)
  if (!joditModulePromise) {
    ensureJoditStylesheet()
    joditModulePromise = new Promise((resolve, reject) => {
      const script = document.createElement('script')
      script.src = 'https://cdn.jsdelivr.net/npm/jodit@4.6.2/es2021/jodit.fat.min.js'
      script.async = true
      script.onload = () => resolve(window.Jodit)
      script.onerror = () => reject(new Error('Jodit failed to load'))
      document.head.appendChild(script)
    })
  }
  return joditModulePromise
}

async function setJodit() {
  const joditButtons = ["bold", "italic", "underline", "paragraph", "ul", "ol", "indent", "outdent", "align", "image", "link", "brush"]
  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

  const joditConfig = {
    placeholder: '',
    askBeforePasteHTML: false,
    askBeforePasteFromWord: false,
    defaultActionOnPaste: 'insert_only_text',
    processPasteHTML: false,
    imageDefaultWidth: null,
    uploader: {
      url: '/uploads',
      insertImageAsBase64URI: false,
      headers: { 'X-CSRF-Token': csrfToken }
    },
    showCharsCounter: false,
    showWordsCounter: false,
    showXPathInStatusbar: false,
    maxHeight: 400,
    buttonsXS: joditButtons,
    buttonsSM: joditButtons,
    buttonsMD: joditButtons,
    buttons: joditButtons
  }

  const textareas = document.querySelectorAll('textarea.jodit')
  if (!textareas.length) return

  const Jodit = await loadJodit()

  textareas.forEach((textarea) => {
    if (textarea.classList.contains('jodit-initialized')) return
    textarea.classList.add('jodit-initialized')
    new Jodit(textarea, joditConfig)
  })
}

document.addEventListener('turbo:load', setJodit)
document.addEventListener('turbo:frame-load', setJodit)
document.addEventListener('turbo:render', setJodit)
